import React from 'react'
import CardSlider from './CardSlider'

const NonActiveReading = ({currentPlayerCard}) => {
  return (
    <div><h3 className="waiting-for-players">Waiting for Players...</h3>
    <CardSlider
      currentPlayerCard={currentPlayerCard?.cards}
      showButton={false} /></div>
  )
}

export default NonActiveReading